import { persist } from "zustand/middleware";
import { create } from "zustand";

type AuthStoreType = {
  token: string;
  setAuth: (token: string) => void;
  clearAuth: () => void;
};

export const useAuthStore = create<AuthStoreType>()(
  persist(
    (set) => ({
      token: "",
      setAuth: (token: string) => {
        set({ token });
      },
      clearAuth: () => {
        set({
          token: "",
        });
      },
    }),
    { name: "authStore" },
  ),
);
